import React from "react";
import { TemplateForm, TemplateFormProps } from "@ploy-ui/template-form";
import { RoutePageProvider } from "../../components/RoutePageProvider";

export const renderTemplateWithRouteState = (props: TemplateFormProps) => (
	<RoutePageProvider
		labelsWithEvents={
			props.template?.pages.map(p => ({
				label: (p.pageUri?.trim().length ?? 0) > 0 ? p.pageUri : p.pageTitle,
				gtmPageEvent: p.gtmPageEvent
			})) ?? []
		}
	>
		<TemplateForm {...props} />
	</RoutePageProvider>
);
